import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface KitchenParamsState {
  params: any; // Define a more specific type if possible
}

const initialState: KitchenParamsState = {
  params: null,
};

const adminConfigurationSliceParams = createSlice({
  name: 'adminConfigurationParams',
  initialState,
  reducers: {
    setadminConfigurationParams(state, action: PayloadAction<any>) {
      state.params = action.payload;
    },
  },
});

export const { setadminConfigurationParams } = adminConfigurationSliceParams.actions;
export default adminConfigurationSliceParams.reducer;
